
import TextInput from '@/mixins/TextInput';

export default {
  name: 'AppSearchInput',
  mixins: [TextInput],
  props: {
    submitLabel: {
      type: String,
      default() {
        return this.$t('cancel');
      }
    },
    isSubmitStatus: { type: Boolean, default: false }
  },
  computed: {
    searchInputIconName() {
      return this.isSubmitStatus ? 'icon-close' : 'icon-search-small';
    }
  },
  methods: {
    click() {
      this.isSubmitStatus ? this.reset() : this.submit();
    },
    reset() {
      this.change(null);
      this.submit();
    },
    cancel() {
      this.reset();
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit', this.currentValue);
    },
    focus() {
      this.$refs.input.focus();
    }
  }
};
